"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeI18n = void 0;
const i18next_1 = __importDefault(require("i18next"));
const i18next_icu_1 = __importDefault(require("i18next-icu"));
class BeI18n {
    constructor({ translations, defaultLanguage, }) {
        this.translations = translations;
        this.defaultLanguage = defaultLanguage;
    }
    async init() {
        await i18next_1.default.use(i18next_icu_1.default).init({
            resources: Object.entries(this.translations).reduce((acc, [key, value]) => {
                acc[key] = {
                    translation: value,
                };
                return acc;
            }, {}),
            lng: this.defaultLanguage,
            fallbackLng: this.defaultLanguage,
            supportedLngs: Object.keys(this.translations),
            defaultNS: "translation",
            ns: ["translation"],
            interpolation: { escapeValue: false, prefix: "{", suffix: "}" },
        });
    }
    getTByLanguage(language) {
        const fixedT = i18next_1.default.getFixedT(language);
        return (key, vars) => {
            return fixedT(key, key, vars);
        };
    }
}
exports.BeI18n = BeI18n;
//# sourceMappingURL=i18n.js.map